import './CollectData.scss';
import BleConnect from 'components/ble/connect/BleConnect';
import ChannelChartStack from 'components/channel/ChannelChartStack';
import ChannelPreview from 'components/channel/ChannelPreview';
import ChannelsService from 'data/ChannelsService';
import Config from 'components/app/config';
import MockChannelConnect from 'components/channel/MockChannelConnect';
import React from 'react';
import Server from 'data/Server';
import Syncer from 'data/Syncer';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Fieldset } from 'primereact/fieldset';
import { FileUpload } from 'primereact/fileupload';


class CollectData extends React.Component {

  constructor() {
    super();
    this.state = { serverSyncActive: false };
    this.channelsService = new ChannelsService.Factory().create();
    this.channelsServiceSubscriptionId = null;
    this.syncer = new Syncer.Factory().create();
    this.server = new Server.Factory().create();
  }

  componentDidMount() {
    this.channelsServiceSubscriptionId =
        this.channelsService.subscribe(this.onChannelsServiceUpdate.bind(this));
  }

  componentWillUnmount() {
    this.channelsService.unsubscribe(this.channelsServiceSubscriptionId);
  }

  onChannelsServiceUpdate(channelData) {
    this.setState(this.state);
  }

  toggleServerSync() {
    const serverSyncActive = !this.state.serverSyncActive;
    this.setState({ serverSyncActive });

    serverSyncActive ? this.syncer.startSync() : this.syncer.stopSync();
  }

  startCsvImport() {
    this.setState({ csvDialogVisible: true });
  }

  render() {
    let deviceCharts;
    let channelList = this.channelsService.getChannelList();
    if (Object.keys(channelList).length > 0) {
      deviceCharts = <ChannelChartStack
          aspectRatio={4} channels={channelList} />;
    } else {
      deviceCharts = <div className='padText'>No channels.</div>;
    }
    const uploadJsx = this.server.cfg('upload') ?
        <Button
            icon='pi pi-upload'
            label='Import CSV data'
            onClick={this.startCsvImport.bind(this)} /> : '';

    return (
      <div className='CollectData section'>
        <Fieldset className='deviceChannels' legend='Device channels'>
          {
            Object.keys(channelList).sort().map(id =>
                <ChannelPreview
                    key={id}
                    channel={channelList[id].channel} />
            )
          }
          {
            Object.keys(channelList).length ? '' :
              <div className='padText'>None connected.</div>
          }
          <div className="buttons">
            <BleConnect
                serviceName='heart_rate' label='Add Bluetooth channel' />
            <MockChannelConnect label='Add mock channel' />
            {uploadJsx}
            <Button
                icon='pi pi-refresh'
                label={this.state.serverSyncActive ?
                    'Stop server sync' : 'Sync to server'}
                onClick={this.toggleServerSync.bind(this)} />
          </div>
          {/*
            TODO
            - refactor this to a standalone component
            - handle confirming with user for success/error cases
          */}
          <Dialog
              header='Import CSV data'
              visible={this.state.csvDialogVisible}
              style={{width: '50vw'}}
              modal={true}
              onHide={() => this.setState({ csvDialogVisible: false })}>
            <FileUpload
                name='csv'
                url={`${Config.serverEndpoint}/api/csv_add`}
                auto={true}
                accept='.csv'
                mode='basic'
                onBeforeSend={e => e.xhr.setRequestHeader(
                  'X-CSRFToken', this.server.csrf()
                )}
                onUpload={() => this.setState({ csvDialogVisible: false })}
                withCredentials={true} />
          </Dialog>
        </Fieldset>
        <Fieldset className='deviceCharts' legend='Channel data'>
          {deviceCharts}
        </Fieldset>
      </div>
    );
  }
}


export default CollectData;
 
